import React from 'react';
import PropTypes from 'prop-types';
import { i18n } from 'core/i18n';

const { formatText } = i18n;

export const DocumentList = ({ documentsList = [], onClickDocumentItem, currentDocumentIndex }) => {
    const firstUnreadDocument = documentsList.find(document => !document.isAccepted);

    const drawDocumentItems = () => {
        if (!Array.isArray(documentsList)) {
            return null;
        }

        return documentsList.map(document => {
            const { documentName, isAccepted } = document;
            const iconClass = isAccepted ? 'icons--icon-success-green-dic' : 'icons--icon-document-dic';
            const itemAcceptedClass = isAccepted ? ' documentation-doc-list-item--accepted' : '';
            const title = formatText(`hireCreditCard-${documentName}`)
            return (
                <li
                    className={`documentation-doc-list-item${itemAcceptedClass}`}
                    onClick={() => onClickDocumentItem(firstUnreadDocument ? firstUnreadDocument : documentsList[currentDocumentIndex], title)}
                    key={documentName}
                >
                    <i className={iconClass}></i>
                    <span>{title}</span>
                </li>
            );
        });
    };

    return <ul className="documentation-doc-list">{drawDocumentItems()}</ul>;
};

DocumentList.propTypes = {
    documentsList: PropTypes.array,
    onClickDocumentItem: PropTypes.func,
};
